module.exports = "pegasus_template/assets/blocks/column-18-theme3.png";